













































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import * as api from '@/services/ApiService'
import appManager from '@/services/AppManager'
import { isBlank } from '@/core/Utils'
import FormTextField from '@/components/FormTextField.vue'
import subscriptionValues from '@/model/SubscriptionValues'
import { extractResponseErrorMessage } from '@/services/ApiService'
import { Coupon } from '@/core/ApiTypes'
import { CouponDurations } from '@/extern/StripeTypes'

@Component({
    components: {
        FormTextField
    }
})
export default class CreateCouponDialog extends Vue {
    @Prop()
    value: boolean|undefined // true to show the dialog
    @Prop()
    onCloseRequested: ((newCoupon?: Coupon) => void)|undefined
    couponName: string|null = 'School Discount'
    couponNameErrorMessage: string|null = null
    companyName: string|null = null                 // optional
    licenseCountOrFixedAmountIndex: number = 0           // 0 = license count; 1 = fixed amount
    licenseCountText: string|null = '1'
    fixedAmountText: string|null = null
    amountErrorMessage: string|null = null          // used for license count or fixed amount error
    formErrorMessage: string|null = null
    isCreating: boolean = false

    onCancelPressed() {
        if (this.onCloseRequested)
            this.onCloseRequested()
    }

    get licenseCount(): number {
        return (this.licenseCountText === null) ? Number.NaN : +this.licenseCountText
    }

    get isLicenseCountValid(): boolean {
        const count = this.licenseCount
        return Number.isFinite(count) && count > 0
    }

    get licenseCountAmountOff(): number {
        return subscriptionValues.getSubtotalPriceYearly(this.licenseCount)
    }

    getLicenseCountAmountOffText(): string {
        if (!this.isLicenseCountValid)
            return '---'

        return subscriptionValues.getPriceText(this.licenseCountAmountOff)
    }

    get fixedAmount(): number {
        return (this.fixedAmountText === null) ? Number.NaN : +this.fixedAmountText
    }

    get isFixedAmountValid(): boolean {
        const amount = this.fixedAmount
        return Number.isFinite(amount) && amount > 0
    }

    async onCreatePressed(): Promise<void> {
        this.validatePage()
        if (this.formErrorMessage)
            return

        this.isCreating = true

        try {
            // if the user entered a fixed amount, convert it from dollars to cents
            const amountOff = (this.licenseCountOrFixedAmountIndex === 0) ? this.licenseCountAmountOff : Math.ceil(this.fixedAmount * 100)
            const newCoupon = await api.createCoupon({
                name: this.couponName!,
                companyName: this.companyName || undefined,
                amountOff: amountOff,
                amountOffCurrency: 'USD',
                maxRedemptions: 1,
                duration: CouponDurations.repeating,
                durationMonths: 12,
            })

            this.formErrorMessage = null

            if (this.onCloseRequested)
                this.onCloseRequested(newCoupon)

            appManager.alertManager.publishSuccess('Coupon successfully added')
        } catch (error) {
            this.formErrorMessage = extractResponseErrorMessage(error) || 'Error creating coupon. Please try again later.'
        }

        // go ahead and log in
        this.isCreating = false
    }

    validatePage() {
        this.couponNameErrorMessage = isBlank(this.couponName) ? 'Specify a coupon name' : null
        if (this.licenseCountOrFixedAmountIndex === 0) {
            this.amountErrorMessage = !this.isLicenseCountValid ? 'Specify a valid license count' : null
        } else {
            this.amountErrorMessage = !this.isFixedAmountValid ? 'Specify a valid fixed amount' : null
        }

        const hasError = !!this.couponNameErrorMessage || !!this.amountErrorMessage
        this.formErrorMessage = hasError ? 'Please correct the error above' : null
    }
}
